<!-- @ts-nocheck -->
<template>
  <q-input
    v-if="isComponentEnabled"
    v-bind="$attrs"
    filled
    :stack-label="!dense"
    :label="label"
    :placeholder="placeholder"
    :align="align"
    :rows="rows"
    :type="type"
    ref="qinput"
    :disable="localdisable && !isTextarea"
    :readonly="readonly || (localdisable && isTextarea)"
    :hint="hint"
    :error="error"
    :error-message="errorMessage"
    :maxlength="maxLength"
    :counter="counter"
    :dense="dense"
    :clearable="clearable"
    v-model="localvalue"
    :autofocus="autofocus"
    @blur="onblur"
    @focus="onfocus"
    @update:modelValue="onchange"
    style="padding-bottom: 0"
    :mask="mask && mask"
    unmasked-value
    :input-class="inputClass"
    autocomplete="off"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </q-input>
  <CuiTextInput
    v-else
    v-model="localvalue"
    :label="label"
    :placeholder="placeholder"
    :type="type"
    :disabled="localdisable"
    :readonly="readonly"
    :maxlength="maxLength"
    :autofocus="autofocus"
    @blur="onblur"
    @focus="onfocus"
    @update:modelValue="onchange"
  />
</template>

<script setup lang="ts">
// @ts-nocheck
import { ref, watch, onMounted, computed } from "vue";
import { QInput } from "quasar";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

defineOptions({ name: "IstFormInput" });

const { isEnabled } = useFeatureFlags();
const isComponentEnabled = computed(() => isEnabled("IstFormInput"));

const props = withDefaults(
  defineProps<{
    validation?: any;
    modelValue?: any;
    disable?: boolean | string;
    dense?: boolean | string;
    placeholder?: string;
    type?: string | null;
    focus?: boolean;
    readonly?: boolean;
    autofocus?: boolean;
    min?: string;
    max?: string;
    minLength?: string;
    maxLength?: string;
    patternErrorMsg?: string;
    pattern?: string;
    rows?: string;
    align?: string;
    hint?: string | null;
    after?: Record<string, unknown>[];
    error?: boolean;
    errorMessage?: string;
    mask?: string;
    counter?: boolean;
    clearable?: boolean | string;
    inputClass?: string;
    label?: string | null;
  }>(),
  {
    modelValue: null,
    disable: false as any,
    dense: false as any,
    placeholder: "",
    type: null,
    focus: false,
    readonly: false,
    autofocus: false,
    min: "",
    max: "",
    minLength: "",
    maxLength: "",
    patternErrorMsg: "",
    pattern: "",
    rows: "",
    align: "",
    hint: null,
    error: false,
    errorMessage: "",
    mask: "",
    counter: false,
    clearable: false as any,
    inputClass: "",
    label: null
  }
);

const emit = defineEmits<{
  blur: [event: Event];
  focus: [event: Event];
  input: [value: any];
  change: [value: any];
  "update:modelValue": [value: any];
}>();

const localvalue = ref<any>("");
const localdisable = ref<boolean>(false);
const qinput = ref<QInput | null>(null);

const isTextarea = computed(() => props.type === "textarea" || (props.rows && props.rows !== ""));

onMounted(() => {
  if (props.focus) {
    qinput.value?.focus();
  }
  localvalue.value = props.modelValue;
  localdisable.value =
    (typeof props.disable === "boolean" && props.disable) || (props.disable as any) == "true";
});

watch(
  () => props.modelValue,
  (modelValue) => {
    if (localvalue.value != modelValue) {
      localvalue.value = modelValue as any;
    }
  }
);
watch(
  () => props.disable,
  (val) => {
    localdisable.value = (typeof val === "boolean" && (val as boolean)) || (val as any) == "true";
  }
);

function onblur(evt: any) {
  emit("blur", evt);
  return evt;
}

function onfocus() {
  emit("focus");
}

function onchange() {
  emit("change", localvalue.value);
  emit("input", localvalue.value);
  emit("update:modelValue", localvalue.value);
  return localvalue.value;
}
</script>

<style>
.ssn-input {
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}
</style>
